module.exports = __webpack_public_path__ + "img/Economics English Medium.d499d3e2.jpg";